import { render } from "./layout.vue?vue&type=template&id=2c7c069a&scoped=true"
import script from "./layout.vue?vue&type=script&lang=ts"
export * from "./layout.vue?vue&type=script&lang=ts"

import "./layout.vue?vue&type=style&index=0&id=2c7c069a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2c7c069a"

export default script